import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";

import EditableText from "app/pages/sales-intelligence/common-components/EditableText/EditableText";
import {
    StyledInput,
    StyledInputContainer,
    StyledText,
} from "app/pages/sales-intelligence/common-components/EditableText/styles";
import OptionsMenu from "app/pages/sales-intelligence/common-components/options-menu/OptionsMenu/OptionsMenu";

export const StyledSavedSearchItemContainer = styled(FlexRow)`
    padding: 5px 16px;
    border-radius: 8px;
    border: 1px solid ${colorsPalettes.carbon[50]};
    cursor: pointer;
    &:hover {
        border: 1px solid ${colorsPalettes.carbon[100]};
        box-shadow: 0px 3px 6px 0px rgba(14, 30, 62, 0.08);
    }
`;

export const StyledCustomIcon = styled(SWReactIcons)`
    margin-right: 8px;
    margin-top: 3px;
    svg {
        width: 16px;
        height: 16px;
    }
`;

export const StyledListItemMainData = styled(FlexColumn)`
    width: 100%;
    height: 40px;
    align-items: flex-start;
    justify-content: space-between;
`;

export const StyledEditableText = styled(EditableText)`
    ${mixins.truncateText()};
    display: flex;
    align-items: center;
    margin-right: 8px;
    overflow: visible;

    & ${StyledText}, & ${StyledInputContainer} ${StyledInput} {
        ${setFontVariant("button", colorsPalettes.carbon[400])};
    }

    & ${StyledText} {
        ${setFontVariant("button", colorsPalettes.carbon[400])};
        display: inline-block;
        width: 150px;
        text-overflow: ellipsis;
        max-width: 100%;
        vertical-align: middle;
    }
`;

export const StyledListLastUpdatedDate = styled.div`
    ${setFontVariant("caption", colorsPalettes.carbon[250])}
    line-height:14px;
`;

export const StyledOptionsMenu = styled(OptionsMenu)`
    padding-right: 16px;
    position: relative;
`;
